<template>
    <v-menu offset-y left>
    <template slot="activator">
      <v-btn color="darkgrey"  flat icon class="button-element" ><v-icon>arrow_drop_down</v-icon></v-btn>
    </template>
    <v-list >
      <v-list-tile v-for="(item, index) in corrections" :key="index" @click="changeCurrentCorrection(item)" :disabled="!canEdit">
        <v-list-tile-title>{{ item }}</v-list-tile-title>
      </v-list-tile>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  props: {
    field: Object,
    corrections: Array,
    correction: String,
    canEdit: Boolean
  },

  methods: {
    changeCurrentCorrection (item) {
      this.$emit('changeCurrentCorrection', item)
    }
  }
}
</script>

<style scoped>
.button-element {
  margin: 0;
}
</style>
